module.exports = __webpack_public_path__ + "static/media/Icons_audio_bold.a436a0c6.svg";